import { MarkdownText } from "@/components/assistant-ui/markdown-text";
import { Reasoning, ReasoningGroup } from "@/components/assistant-ui/reasoning";
import { ToolFallback, ToolGroup } from "@/components/assistant-ui/tool-fallback";
import { AskCard } from "@/components/assistant-ui/tools/ask-card";
import { AskOpenCard } from "@/components/assistant-ui/tools/ask-open-card";

// ─── Module-level constants ──────────────────────────────────────────────────
// Created once per module load; stable references prevent unnecessary
// re-renders in memoized children that receive these as props.

/** Pasted text longer than this (in characters) is auto-converted to a .txt attachment. */
export const PASTE_TO_ATTACHMENT_THRESHOLD = 3000;

export const THREAD_STYLE = { ["--thread-max-width" as string]: "56rem" };

export const SHOW_THREAD_LIST_CLASSES =
  "aui-thread-viewport-footer sticky bottom-0 mx-auto mt-auto flex w-full max-w-(--thread-max-width) flex-col gap-4 overflow-visible rounded-t-3xl bg-background pb-4 md:pb-6";

export const NO_THREAD_LIST_CLASSES =
  "fixed bottom-0 px-3 left-0 right-0 mx-auto w-full max-w-(--thread-max-width) bg-background pb-4 md:pb-6 sticky bottom-0";

// Stable reference for MessagePrimitive.Parts — avoids breaking its internal
// memoization on every streaming token (AssistantMessage re-renders frequently).
export const ASSISTANT_MESSAGE_PART_COMPONENTS = {
  Text: MarkdownText,
  Reasoning: Reasoning,
  ReasoningGroup: ReasoningGroup,
  ToolGroup: ToolGroup,
  // assistant-ui v0.12 resolves per-tool renderers via `tools.by_name[toolName]`
  // (see node_modules/@assistant-ui/react/dist/primitives/message/MessagePartsGrouped.js
  // `const Tool = tools.by_name?.[part.toolName] ?? tools.Fallback`). Placing the
  // components at the top level of `tools` falls through to `Fallback` for every
  // tool-call part — the symptom was `select` / `text_input` rendering as
  // ToolFallback ("Použitý nástroj: ...") instead of their interactive cards.
  tools: {
    by_name: {
      ask: AskCard,
      ask_open: AskOpenCard,
    },
    Fallback: ToolFallback,
  },
};
